import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { DiffusionTarget } from './DiffusionTarget';
import DiffusionModal from 'modules/diffusion/components/DiffusionModal';
import {
  loadInitialDatas,
  openModal,
  closeModal,
  addTarget,
  removeTarget,
  clearTarget,
} from '../actions/index';
import { getTargets, isModalOpened, isEditable } from '../reducers/index';
import ImmutablePropTypes from 'react-immutable-proptypes';

const mapStateToProps = state => ({
  targets: getTargets(state),
  isModalOpened: isModalOpened(state),
  isEditable: isEditable(state),
});

const mapDispatchToProps = dispatch => ({
  loadInitialDatas: () => dispatch(loadInitialDatas()),
  openModal: () => dispatch(openModal()),
  closeModal: () => dispatch(closeModal()),
  addTarget: target => dispatch(addTarget(target)),
  removeTarget: pos => dispatch(removeTarget(pos)),
  clearTarget: () => dispatch(clearTarget()),
});

export class DiffusionList extends React.Component {
  static propTypes = {
    targets: ImmutablePropTypes.map.isRequired,
    loadInitialDatas: PropTypes.func.isRequired,
    isModalOpened: PropTypes.bool.isRequired,
    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    addTarget: PropTypes.func.isRequired,
    removeTarget: PropTypes.func.isRequired,
    clearTarget: PropTypes.func.isRequired,
    isEditable: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    props.loadInitialDatas();
    this.onSelection = this.onSelection.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onSelection(result) {
    //  this.props.closeModal()
    const target = {
      profile: result.profile,
      region: result.region,
      department: result.department,
      tags: result.tags,
    };
    this.props.addTarget(target);
  }

  onDelete(pos) {
    return () => {
      this.props.removeTarget(pos);
    };
  }

  render() {
    const {
      targets,
      isModalOpened,
      openModal,
      closeModal,
      clearTarget,
      isEditable,
    } = this.props;

    return (
      <div className="ui segment raised">
        <div className="ui medium header">
          Liste de diffusion
          {isEditable === true && (
            <span style={{ float: 'right' }}>
              <a
                className="ui compact labeled icon button"
                onClick={clearTarget}
              >
                <i className="recycle icon" />
                Vider
              </a>
              <a className="ui compact labeled icon button" onClick={openModal}>
                <i className="add user icon" />
                Ajouter
              </a>
            </span>
          )}
        </div>

        {targets.size > 0 && (
          <table className="ui basic table">
            <thead>
              <tr>
                <th>Profils</th>
                <th>Régions</th>
                <th>Départements</th>
                <th>Tags</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {targets.map(t => (
                <DiffusionTarget
                  key={targets.keyOf(t)}
                  target={t}
                  onDelete={this.onDelete(targets.keyOf(t))}
                  isEditable={isEditable}
                />
              ))}
            </tbody>
          </table>
        )}
        {targets.size === 0 && (
          <div className="ui icon message">
            <i className="circle info icon" />
            <div className="content">
              <div className="header">
                Liste de diffusion vide. Actualité visible par tous
              </div>
            </div>
          </div>
        )}

        {isModalOpened && (
          <DiffusionModal
            id="modal-news-diffusion"
            name="diffusion"
            title="Ajout de destinataires"
            isOpened={isModalOpened}
            validationCallback={this.onSelection}
            cancelCallback={closeModal}
            selectable={false}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiffusionList);



// WEBPACK FOOTER //
// ./src/modules/news/components/DiffusionList.js